import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import './saas/ui/tenant-tokens.css'
import './saas/ui/object-image-theme.css'
import './saas/ui/action/action-popover.css'
import { bootstrapPlatformFavicon } from './saas/platformBranding'
import { applyThemeToDocument, getThemePreference } from './saas/ui/themePreference'
import { installMemoryRuntimeProbe } from './saas/utils/memoryRuntimeProbe'

applyThemeToDocument(getThemePreference())
installMemoryRuntimeProbe()
void bootstrapPlatformFavicon()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
